import React from "react";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import ControlledDialog from "./ControlledDialog";

class ConfirmationDialog extends React.Component {
  constructor(props) {
    super(props);
  }

  reject = () => {
    this.props.dialogHandler.reject();
  };

  resolve = () => {
    this.props.dialogHandler.resolve();
  };

  render() {
    const { dialogHandler, title, message } = this.props;
    return (
      <div id="dialogNotifications">
        <ControlledDialog
          handler={dialogHandler}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle
            id="form-dialog-title"
            style={{ background: "#FFEB3B", color: "#000", marginBottom: 20 }}
          >
            {title}
          </DialogTitle>
          <DialogContent>{message}</DialogContent>
          <DialogActions style={{}}>
            <Button onClick={this.resolve} color="primary">
              Aceptar
            </Button>
            <Button onClick={this.reject} color="primary">
              Cancelar
            </Button>
          </DialogActions>
        </ControlledDialog>
      </div>
    );
  }
}

export default ConfirmationDialog;
